var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-expand-lg navbar-fixed" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "navbar-minimize" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block",
            on: { click: _vm.minimizeSidebar }
          },
          [
            _c("font-awesome-icon", {
              staticClass: "fa fa5",
              attrs: { icon: _vm.$sidebar.isMinimized ? "bars" : "ellipsis-v" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "navbar-brand" }, [
        _vm._v(_vm._s(this.$route.name))
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "navbar-toggler navbar-toggler-right",
          class: { toggled: _vm.$sidebar.showSidebar },
          attrs: { type: "button", "aria-expanded": "false" },
          on: { click: _vm.toggleSidebar }
        },
        [
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse justify-content-end" },
        [
          _c(
            "ul",
            { staticClass: "navbar-nav" },
            [
              _c(
                "drop-down",
                {
                  ref: "notificationDropdown",
                  staticClass: "dropdown-notifications",
                  attrs: { position: "right" },
                  on: { change: _vm.dropDownOnChange }
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { staticClass: "nc-icon nc-bell-55" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "notification" }, [
                      _vm._v(_vm._s(_vm.notificationList.length))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-lg-none" }, [
                      _vm._v("Notification")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.notificationList, function(notification, index) {
                    return _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            value: notification.hasLongText,
                            expression: "notification.hasLongText",
                            modifiers: { hover: true }
                          }
                        ],
                        key: index,
                        staticClass: "dropdown-item",
                        attrs: {
                          href: "#" + notification.href,
                          title: notification.hasLongText
                            ? notification.title
                            : null
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.readNotification(
                              notification.uuid,
                              notification.href
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(notification.title) +
                            "\n              "
                        ),
                        _c(
                          "small",
                          { staticClass: "time" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["far", "clock"] }
                            }),
                            _vm._v(" " + _vm._s(notification.createdAt))
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item py-2 text-center",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.seeAllNotification($event)
                        }
                      }
                    },
                    [_vm._v("See all notifications")]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("drop-down", { attrs: { position: "right" } }, [
                _c("i", {
                  staticClass: "nc-icon nc-bullet-list-67",
                  attrs: { slot: "title" },
                  slot: "title"
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#/profile" }
                  },
                  [
                    _c("i", { staticClass: "nc-icon nc-single-02" }),
                    _vm._v(" Profile\n          ")
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item text-danger",
                    attrs: { href: "#/logout" }
                  },
                  [
                    _c("i", { staticClass: "nc-icon nc-button-power" }),
                    _vm._v(" Log out\n          ")
                  ]
                )
              ])
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f5d75f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f5d75f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/TopNavbar.vue
// module id = S2Mr
// module chunks = 4